// DataContext.js
import React, { createContext, useEffect, useState } from 'react';

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
	const [isIntersecting, setIsIntersecting] = useState(false);

	const [toggleMode, setToggleMode] = useState(false);
	useEffect(() => {
		const isDarkMode = localStorage.getItem('darkMode');
		if (isDarkMode === 'true') {
			setToggleMode(true);
		}
	}, []);

	useEffect(() => {
		if (toggleMode) {
			document.body.classList.add('dark-mode');
			localStorage.setItem('darkMode', 'true');
		} else {
			document.body.classList.remove('dark-mode');
			localStorage.setItem('darkMode', 'false');
		}
	}, [toggleMode]);

	const handleClick = () => {
		setToggleMode((prevMode) => !prevMode);
	};
	return (
		<DataContext.Provider
			value={{
				isIntersecting,
				setIsIntersecting,
				toggleMode,
				handleClick,
				setToggleMode,
			}}>
			{children}
		</DataContext.Provider>
	);
};
